<mat-toolbar class="sticky-header">
  <a routerLink="/" class="brand-link">
    <img src="assets/NewLogo.webp" height="44" alt="Chareety">
  </a>
  <span class="toolbar-spacer"></span>
  <nav class="nav-links">
    <a href="#features">Features</a>
    <a href="#pricing">Pricing</a>
    <a href="#compare">Compare</a>
    <a href="#calculator">Calculator</a>
    <a href="#faq">FAQ</a>
  </nav>
  <button mat-button class="get-started-btn" (click)="navigateToOnboard()">
    Get Started
  </button>
</mat-toolbar>

<main class="main-content">
  <router-outlet></router-outlet>
</main>

<footer class="footer">
  <div class="footer-container">
    <div class="footer-brand">
      <img src="assets/NewLogo.webp" height="32" alt="Chareety">
      <p class="footer-tagline">Nonprofit donation platform</p>
    </div>
    <div class="footer-links">
      <a routerLink="/privacy">Privacy Policy</a>
      <a routerLink="/terms">Terms of Service</a>
      <a href="#contact">Contact</a>
    </div>
    <div class="copyright">
      &copy; {{ currentYear }} Chareety. All Rights Reserved.
    </div>
  </div>
</footer>
<app-cookie-consent></app-cookie-consent>
